export const environment = {
  production: true,
  authBaseUri: "__authBaseUri__",
  redirectUri: "__redirectUri__",
  wbQuoteUri: "__wbQuoteUri__",
  wbQuoteLiteUri: "__wbQuoteLiteUri__",
  env: "__env__",
  idleTime: 3000,
  idleTimeout: 10,
  apiEndPoints: {
    ratesTableApiBaseUri: "__ratesTableApiBaseUri__",
    censusLiteApiBaseUri: "__censusLiteApiBaseUri__",
    planLiteApiBaseUri: "__planLiteApiBaseUri__",
    quoteLiteApiBaseUri: "__quoteLiteApiBaseUri__",
    authBaseUri: "__authBaseUri__",
    userApiBaseUri: "__userApiBaseUri__",
    nqsPlanApiBaseUri: "__nqsPlanApiBaseUri__",
    nqsQuoteApiBaseUri: "__nqsQuoteApiBaseUri__",
    redirectUri: "__redirectUri__",
    medIdApiUri: "__medIdApiUri__",
    carrierLogosUri: "__carrierLogosUri__",
    cspObjectSrc: "__cspObjectSrc__",
    cspConnectSrc: "__cspConnectSrc__",
    cspFontSrc: "__cspFontSrc__",
    cspFrameSrc: "__cspFrameSrc__",
    cspImgSrc: "__cspImgSrc__",
    cspMediaSrc: "__cspMediaSrc__",
    cspScriptSrc: "__cspScriptSrc__",
    cspStyleSrc: "__cspStyleSrc__",
    cspRequireTrustedTypesFor: "__cspRequireTrustedTypesFor__",
    enableCSP: "__enableCSP__",
    AuthRequireHttps: "__AuthRequireHttps__",
    SingleSignoutRedirect: "__SingleSignoutRedirect__",
    AuthSessionChecksEnabled: "__AuthSessionChecksEnabled__",
    contributionHost: '__contributionHost__',
    contributionEndPoint: '/dynamicComponent.js',
  },
};
